import { REFUND_TRANSACTION_STATUS, TransactionStatus } from "@/types/api";

export enum PaymentsMethods {
  CARD = "CARD",
  APPLE_PAY = "APPLE_PAY",
  GOOGLE_PAY = "GOOGLE_PAY",
  STC_PAY = "STC_PAY",
  SELFSERVE_WALLET = "SELFSERVE_WALLET",
  CARD_AND_SELFSERVE_WALLET = "CARD_AND_SELFSERVE_WALLET",
  APPLE_PAY_AND_SELFSERVE_WALLET = "APPLE_PAY_AND_SELFSERVE_WALLET",
}

export interface ITransactions {
  id: string;
  referenceNumber: string;
  orderCode: string;
  createdAt: string;
  grossAmount: string;
  tipsAmount: string;
  taxAmount: string;
  netAmount: string;
  paymentMethod: PaymentsMethods;
  status: TransactionStatus;
  cashbackEarned: string;
  cashbackSpent: string;
  creditRedeemed: string;
  usedWallet: boolean;
  totalPayable: string;
  billNumber: string;
  branchName?: string;
  brandName?: string;
  isPartial?: boolean;
  tableNumber?: string | null;
  paymentRefundStatus: REFUND_TRANSACTION_STATUS;
}

export const statusMap: Record<string, TransactionStatus> = {
  Pending: TransactionStatus.PENDING,
  Initiated: TransactionStatus.INITIATED,
  Completed: TransactionStatus.COMPLETED,
  Failed: TransactionStatus.FAILED,
  Cancelled: TransactionStatus.CANCELLED,
  Expired: TransactionStatus.EXPIRED,
  Declined: TransactionStatus.DECLINED,
  Aborted: TransactionStatus.ABORTED,
};

export interface ITransactionStats {
  totalTips: number;
  totalSettled: number;
  pendingToSettle: number;
}

export interface TransactionsStatsParams {
  dateFrom?: string;
  dateTo?: string;
}

export interface LiveTransaction {
  id: string;
  referenceNumber: string;
  orderCode: string;
  billNumber: string;
  totalAmount: number;
  billAmount: number;
  tipsAmount: number;
  createdAt: string;
  tableNumber: string | null;
  remainingDue: number;
  status: TransactionStatus;
  isPartial: boolean;
  orderId: string;
}
